



















import Vue from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import HistoryItem from '@/components/molecules/HistoryItem.vue'
import { State as UsersState } from '@/store/modules/users'
import { State as TransactionsState } from '@/store/modules/transactions'

export default Vue.extend({
  name: 'HistoryPoint',
  components: {
    PageTitle,
    SimpleLoader,
    HistoryItem
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.transactions.isTransactionsLoading || this.$state.users.isProfileLoading
    },
    transactions(): TransactionsState['transactions'] | null {
      return this.$state.transactions.transactions
    },
    profile(): UsersState['profile'] | null {
      return this.$state.users.profile
    }
  },
  methods: {
    hasUsed(name: string): boolean {
      return this.profile ? this.profile.name === name : false
    },
    messageText(name: string, message: string): string {
      return this.profile && this.profile.name === name ? `${message}ポイントを使用` : `${message}ポイントを獲得`
    }
  },
  mounted() {
    this.$store.dispatch('transactions/fetchTransactions')
    this.$store.dispatch('users/fetchProfile')
  }
})
